import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    services: null,
    servicesFetched: false,
    fetchingServices: false,
  },
  mutations: {
    SET_SERVICES(state, data) {
      state.services = data.result
      state.servicesFetched = true
    },
    SET_FETCHING_SERVICES(state, value) {
      state.fetchingServices = value
    },
  },
  actions: {
    fetchServices({ commit }) {
      commit('SET_FETCHING_SERVICES', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}/services`, { noSignalNeeded: true })
          .then(response => {
            commit('SET_SERVICES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_SERVICES', false)
          })
      })
    },
  },
}
